import React, { Component } from 'react';
import { connect } from 'react-redux';
import countryList from 'react-select-country-list';
import { Input } from 'reactstrap';

import { redirectToCheckout } from 'functions/redirectToCheckout';
import { Spinner } from 'components/Spinner/spinner';
import { toast } from 'react-toastify';
import * as appConstants from 'util/appConstants';
import { setPlanDetails } from 'global/actions/rootActions';
import PrimusHandler from 'api/primusHandler';
import OptionsTab from 'components/optionsTab/optionsTab';
import PurchaseSelection from 'components/PurchaseSelection/PurchaseSelection';
import Path from 'routes/Path';
import './main.css';
import { AppContainer, AppWrapper } from './styles';
import Dropdown from '../../components/Dropdown';
import { checkVATForCountries } from 'functions/checkVATForCountries';
import { Button } from '../../components';
import InformationModal from 'components/Modals/informationModal';

let countries = countryList().getData();
class SubscriptionPlans extends Component {
  state = {
    plans: [],
    defaultPlanKey: null,
    activeTabName: appConstants.paymentTabs.purchase,
    selectedPlanDetails: null,
    planDetails: [],
    isInitialPageLoad: false,
    purchasePlan: {},
    loading: false,
    country: '',
    countries: [],
    vatId: '',
    hasCountry: false,
    hasVatId: false,
    vatStatus: '',
    company: '',
    showInformationModal: false,
  };

  componentDidMount() {
    let copyOfCountries = [...countries];
    copyOfCountries.unshift({ label: 'Select country', value: '' });
    this.setState({ countries: copyOfCountries });
    let interval = setInterval(() => {
      clearInterval(interval);
      PrimusHandler.sendRequest({ _handler: 'load-plans', isReact: true });
    }, 200);
  }

  UNSAFE_componentWillReceiveProps = (props) => {
    if (props.create_payment && props.create_payment.data) {
      redirectToCheckout(props.create_payment.data);
    } else if (props.create_payment && !props.create_payment.success) {
      toast.error('Failed to create payment');
      this.setState({
        loading: false,
      });
    }
    if (props.update_company) {
      this.setState({
        loading: false,
      });
      if (!props.update_company?.success) return toast.error(props.update_company.error);
      if (props.update_company.company?.VATInformation?.verification?.status === 'pending') {
        this.setState({
          showInformationModal: true,
          hasVatId: true,
          hasCountry: true,
          vatId: props.update_company.company.VATInformation.vatId,
          vatStatus: props.update_company.company.VATInformation.verification.status,
        });
      }
    }
    if (props.load_plans && props.load_plans.success && props.load_plans.data) {
      props.load_plans.data.map((plan, index) => {
        return plan;
      });

      if (props.load_plans.company) this.setState({ company: props.load_plans.company });
      if (props.load_plans.country) {
        this.setState({ hasCountry: true, country: props.load_plans.country });
        if (props.load_plans.VATInformation)
          this.setState({
            hasVatId: true,
            vatId: props.load_plans.VATInformation.vatId,
            vatStatus: props.load_plans.VATInformation.verification.status,
          });
      }

      let recurringPlan = props.load_plans.data.filter((plan, index) => {
        if (plan.recurring) {
          return plan;
        } else return null;
      });
      let purchasePlan = props.load_plans.data.filter((plan, index) => {
        if (!plan.recurring) {
          return plan;
        } else return null;
      });
      this.setState({
        planDetails: recurringPlan,
        purchasePlan,
      });
    } else if (props.load_plans && !props.load_plans.success) {
      toast.success(props.load_plans.error);
    }
  };

  purchase = (planDetails) => {
    planDetails = { ...planDetails };
    let params = {
      isReact: true,
    };
    if (!this.state.hasCountry && this.state.country) params.country = this.state.country;
    if (!this.state.hasVatId && this.state.vatId) {
      params.VATInformation = {
        vatId: this.state.vatId,
      };
      params._handler = 'update-company';
      params.operation = 'updateCompany';
      params._id = this.state.company;
      this.setState({
        loading: true,
      });
      return PrimusHandler.sendRequest(params);
    }

    if (this.state.purchasePlan[0] && this.state.purchasePlan[0].price) {
      this.setState({
        loading: true,
      });
      planDetails.pricePerTest = this.state.purchasePlan[0].price;
      let paymentDetails = {
        _handler: 'create-payment',
        credits: planDetails.credits ? planDetails.credits : 'Unlimited',
        planID: planDetails._id,
        planType: planDetails.name,
        recurring: planDetails.recurring,
        currency: planDetails.selectedCurrency,
        isReact: true,
      };
      if (this.state.country) paymentDetails.country = this.state.country;
      PrimusHandler.sendRequest(paymentDetails);
    }
  };

  handleTabs = (tab) => {
    this.setState({ activeTabName: tab });
  };

  selectedPlan = (planDetails) => {
    this.setState({ defaultPlanKey: planDetails._id, selectedPlanDetails: planDetails });
  };

  recurringPlans = () => {
    return (
      <div>
        <h4>To purchase a plan, please contact</h4>
        <a style={{ color: '#295c88', fontWeight: 'bold' }} href="mailto:sales@futureskill.com">
          sales@futureskill.com
        </a>
      </div>
    );
  };

  purchaseTestPlans = () => {
    if (this.state.purchasePlan[0]) {
      return (
        <PurchaseSelection purchaseData={this.state.purchasePlan[0]} setPurchaseDetails={this.props.setPlanDetails} />
      );
    }
  };

  isPurchaseButtonDisabled = () => {
    if (this.state.loading) return true;
    if (!this.state.hasCountry && !this.state.country) return true;
    if (this.state.hasVatId && this.state.vatStatus === 'pending') return true;
    return false;
  };

  render() {
    return (
      <AppContainer>
        <AppWrapper>
          {/* TODO: Need to change the text of below line */}
          {this.state.showInformationModal && (
            <InformationModal
              title="VAT Information"
              text="VAT verification is pending. This usually takes 1-2 minutes. You can see the status on your company settings page."
              closeModal={() => this.setState({ showInformationModal: false })}
            />
          )}
          <div>
            {this.state.loading && (
              <div>
                <Spinner
                  title="Please wait while your payment is processing"
                  text="Do not refresh / reload the page until processing is done..."
                />
              </div>
            )}
            <OptionsTab
              handleTabs={this.handleTabs}
              activeTab={this.state.activeTabName}
              options={Object.values(appConstants.paymentTabs)}
            />
            <div id="container">
              {this.state.activeTabName === appConstants.paymentTabs.recurring
                ? this.recurringPlans()
                : this.purchaseTestPlans()}
            </div>

            {this.state.activeTabName === appConstants.paymentTabs.purchase &&
              this.state.purchasePlan[0] &&
              (!this.state.hasCountry ||
                (this.state.hasCountry && !this.state.hasVatId && checkVATForCountries(this.state.country))) && (
                <Dropdown
                  width="200px"
                  value={this.state.country}
                  margin="9px 0 0 0"
                  justifyContent="center"
                  options={this.state.countries}
                  onChange={(result) => this.setState({ country: result.value })}
                />
              )}
            {this.state.activeTabName === appConstants.paymentTabs.purchase &&
              this.state.country &&
              !this.state.hasVatId &&
              checkVATForCountries(this.state.country) && (
                <Input
                  type="text"
                  placeholder="VAT ID"
                  name="VAT"
                  className="VATField"
                  value={this.state.vatId}
                  onChange={(e) => this.setState({ vatId: e.target.value })}
                />
              )}
            <div className="purchase">
              {this.state.activeTabName === appConstants.paymentTabs.recurring ? null : (
                <Button
                  primaryBlue
                  primaryGreenBorder
                  margin="0 0 10px 0"
                  padding="7px 50px 7px 50px"
                  disabled={this.isPurchaseButtonDisabled()}
                  onClick={() => this.purchase(this.props.planDetails)}
                >
                  Purchase
                </Button>
              )}
            </div>
            <div>
              {this.state.vatStatus === 'pending' && (
                <span className="verification-message">
                  {/* TODO: Need to change the text of below line */}
                  VAT verification is pending. This usually takes 1-2 minutes. You can see the status on your company
                  settings page.
                  <br />
                  Please wait until the verification is completed otherwise you will get charged 25% VAT.
                </span>
              )}
              <a className="paymentLink" href={Path.payments}>
                Click here to see your previous purchases
              </a>
            </div>
          </div>
        </AppWrapper>
      </AppContainer>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    planDetails: state.data.planDetails,
    defaultPlanKey: state.data.defaultPlanKey,
    primus_response: state.data.primus_response,
    load_plans: state.data['load-plans'],
    create_payment: state.data['create-payment'],
    update_company: state.data['update-company'],
  };
};

export default connect(mapStateToProps, { setPlanDetails })(SubscriptionPlans);
